import { Component } from '@angular/core';

@Component({
  selector: 'app-zentra-config-page',
  templateUrl: './zentra-config-page.component.html',
  styleUrls: ['./zentra-config-page.component.scss'],

  standalone: false,
})
export class ZentraConfigPageComponent {}
